import React, { Component, createRef } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Импорт стилей Swiper
import 'swiper/css'
import 'swiper/css/navigation'

class App extends Component {
  constructor(props) {
    super(props)
    this.swiperRef = createRef()
    this.state = {
      isBeginning: true,
      isEnd: false,
      lightboxOpen: false,
      currentImageIndex: 0
    }
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    })
  }

  // Открыть lightbox с выбранным изображением
  openLightbox = (index) => {
    this.setState({
      lightboxOpen: true,
      currentImageIndex: index
    })
    // Блокируем прокрутку страницы
    document.body.style.overflow = 'hidden'
  }

  // Закрыть lightbox
  closeLightbox = () => {
    this.setState({
      lightboxOpen: false
    })
    // Возвращаем прокрутку страницы
    document.body.style.overflow = 'auto'
  }

  // Переключение на следующее изображение
  nextImage = () => {
    const { production_capacity } = this.props.data
    const { currentImageIndex } = this.state
    
    if (currentImageIndex < production_capacity.items.length - 1) {
      this.setState({
        currentImageIndex: currentImageIndex + 1
      })
    }
  }

  // Переключение на предыдущее изображение
  prevImage = () => {
    const { currentImageIndex } = this.state
    
    if (currentImageIndex > 0) {
      this.setState({
        currentImageIndex: currentImageIndex - 1
      })
    }
  }

  // Обработка нажатия клавиш
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return
    
    if (e.key === 'Escape') {
      this.closeLightbox()
    } else if (e.key === 'ArrowRight') {
      this.nextImage()
    } else if (e.key === 'ArrowLeft') {
      this.prevImage()
    }
  }

  componentDidMount() {
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown)
    document.body.style.overflow = 'auto'
  }

  render() {
    const { data } = this.props
    const { production_capacity } = data
    const { isBeginning, isEnd, lightboxOpen, currentImageIndex } = this.state

    if (!production_capacity || !production_capacity.items) {
      return null
    }

    const images = production_capacity.items
    const currentImage = images[currentImageIndex]

    return (
      <>
        <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
          <div className='container'>
            <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.75 16.5H3.75C2.25 16.5 1.5 15.75 1.5 14.25V8.25C1.5 6.75 2.25 6 3.75 6H7.5V14.25C7.5 15.75 8.25 16.5 9.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.58249 3C7.52249 3.225 7.5 3.4725 7.5 3.75V6H3.75V4.5C3.75 3.675 4.425 3 5.25 3H7.58249Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.75 12.75H11.25C10.8375 12.75 10.5 13.0875 10.5 13.5V16.5H13.5V13.5C13.5 13.0875 13.1625 12.75 12.75 12.75Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.5 9.75V12.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.5 14.25V3.75C7.5 2.25 8.25 1.5 9.75 1.5H14.25C15.75 1.5 16.5 2.25 16.5 3.75V14.25C16.5 15.75 15.75 16.5 14.25 16.5H9.75C8.25 16.5 7.5 15.75 7.5 14.25Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>Производственные мощности</div>
              </div>
            </div>
            
            <div className='flex items-end justify-between gap-[20px]'>
              <h2 className='font-medium mt-[20px] xl:mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(production_capacity?.title)}</h2>
              
              {/* Кастомная навигация */}
              <div className='hidden xl:flex items-center gap-[5px]'>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="white"/>
                  </svg>
                </div>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white"/>
                  </svg>
                </div>
              </div>
            </div>

            {/* Слайдер с изображениями */}
            <div className='hidden xl:block'>
              <Swiper
                onSwiper={(swiper) => {
                  this.swiperRef.current = swiper
                  this.handleSlideChange(swiper)
                }}
                onSlideChange={this.handleSlideChange}
                modules={[Navigation]}
                spaceBetween={10}
                slidesPerView={5}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 10
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 10
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 10
                  },
                  1280: {
                    slidesPerView: 5,
                    spaceBetween: 10
                  }
                }}
                className='production-slider py-[20px]'
              >
                {images.map((item, index) => (
                  <SwiperSlide key={index} className="h-auto flex items-center rounded-[15px] overflow-hidden bg-[#f5f7f9]">
                    <div 
                      className='cursor-pointer transition-transform hover:scale-105 duration-300 w-full'
                      onClick={() => this.openLightbox(index)}
                    >
                      <img 
                        src={item.image} 
                        alt={item.alt || `Производственная мощность ${index + 1}`} 
                        className='w-full h-[360px] object-cover'
                        loading="lazy"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <div className='mt-[30px] xl:hidden w-[calc(100%+10px)] overflow-x-auto overflow-y-hidden flex items-center gap-[10px] pb-[10px]'>
              {images.map((item, index) => (
                <div 
                  key={index}
                  className='rounded-[15px] overflow-hidden cursor-pointer w-[194px] flex-none'
                  onClick={() => this.openLightbox(index)}
                >
                  <img 
                    src={item.image} 
                    alt={item.alt || `Производственная мощность ${index + 1}`} 
                    className='w-full h-[260px] object-cover rounded-[15px]'
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Lightbox для увеличения фото */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Кнопка предыдущего изображения */}
            {currentImageIndex > 0 && (
              <button 
                className='absolute left-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10'
                onClick={(e) => {
                  e.stopPropagation()
                  this.prevImage()
                }}
              >
                ‹
              </button>
            )}

            {/* Изображение */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={currentImage?.image} 
                alt={currentImage?.alt || 'Увеличенное изображение'}
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Счетчик изображений */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-50 px-4 py-2 rounded-full text-sm'>
                {currentImageIndex + 1} / {images.length}
              </div>
            </div>

            {/* Кнопка следующего изображения */}
            {currentImageIndex < images.length - 1 && (
              <button 
                className='absolute right-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10'
                onClick={(e) => {
                  e.stopPropagation()
                  this.nextImage()
                }}
              >
                ›
              </button>
            )}
          </div>
        )}
      </>
    );
  }
}

export default App